// YunEmSet.js

import React from 'react'
import './YunEmSet.css';
import YunSection from '../YunSection/YunSection'
import { forMatTune } from '../../../utils/index'

const YunEmSet = function(props) {
    const { currentKeynote, setCurrentKeyNote, emSharpFlatState, sharpFlatState, setIsCheckedAiEm } = props
    const [submitMsg, setSubmitMsg] = React.useState('')
    const emConfigList = [{
        name: '大调',
        keynoteList: [{
            name: 'C'
        }, {
            name: 'Db'
        }, {
            name: 'D'
        }, {
            name: 'Eb'
        }, {
            name: 'E'
        }, {
            name: 'F'
        }, {
            name: 'F#'
        }, {
            name: 'G'
        }, {
            name: 'Ab'
        }, {
            name: 'A'
        }, {
            name: 'Bb'
        }, {
            name: 'B'
        }],
    }, {
        name: '小调',
        keynoteList: [{
            name: 'C'
        }, {
            name: 'C#'
        }, {
            name: 'D'
        }, {
            name: 'Eb'
        }, {
            name: 'E'
        }, {
            name: 'F'
        }, {
            name: 'F#'
        }, {
            name: 'G'
        }, {
            name: 'G#'
        }, {
            name: 'A'
        }, {
            name: 'Bb'
        }, {
            name: 'B'
        }],
    }, {
        name: '彩色调',
        keynoteList: [{
            name: 'C'
        }, {
            name: 'C#'
        }, {
            name: 'D'
        }, {
            name: 'D#'
        }, {
            name: 'E'
        }, {
            name: 'F'
        }, {
            name: 'F#'
        }, {
            name: 'G'
        }, {
            name: 'G#'
        }, {
            name: 'A'
        }, {
            name: 'A#'
        }, {
            name: 'B'
        }],
    }]

    let CurrentKeynoteList = getScaleList(currentKeynote.newScale)
    let CurrentScale = currentKeynote.newScale
    let CurrentKeynote = currentKeynote.newKeyNote

    let keynoteList = CurrentKeynoteList.map((keynote, index) => {
        const classNameStr = (CurrentKeynote === keynote.name) ? 'KeynoteItem YunBtn Active' : 'KeynoteItem YunBtn'
        return (
            <div onClick={() => changeKeynote(keynote)} className={classNameStr} key={'keynote' + index}>
                {keynote.name}
            </div>
        )
    });

    let scaleList = emConfigList.map((scale, index) => {
        const classNameStr = (CurrentScale === scale.name) ? 'ScaleItem YunBtn Active' : 'ScaleItem YunBtn'
        return (
            <div onClick={() => changeScale(scale)} className={classNameStr} key={'scale' + index}>
                {scale.name}
            </div>
        )
    })

    function changeKeynote(keynote) {
        // setKeynote(keynote.name)
        setCurrentKeyNote({
            musicAuthor: currentKeynote.musicAuthor,
            musicKeynote: currentKeynote.musicKeynote,
            musicName: currentKeynote.musicName,
            musicProcess: currentKeynote.musicProcess,
            newKeyNote: keynote.name,
            newScale: currentKeynote.newScale,
            type: "EM_KN_ZX",
        })
        setIsCheckedAiEm(false);
    }

    function changeScale(scale) {
        setCurrentKeyNote({
            musicAuthor: currentKeynote.musicAuthor,
            musicKeynote: currentKeynote.musicKeynote,
            musicName: currentKeynote.musicName,
            musicProcess: currentKeynote.musicProcess,
            newKeyNote: currentKeynote.newKeyNote,
            newScale: scale.name,
            type: "EM_KN_ZX",
        })
        setIsCheckedAiEm(false);
    }

    // 手动提交当前基调（纠错）
    function submitReport(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (!window.__reportKeynote) {
            setSubmitMsg('提交失败：组件未就绪');
            setTimeout(() => setSubmitMsg(''), 3000);
            return;
        }
        const startAt = Date.now();
        setSubmitMsg('提交中…');
        window.__reportKeynote('手动');
        const timer = setInterval(() => {
            const r = window.__keynoteReportResult;
            if (r && r.at >= startAt) {
                clearInterval(timer);
                setSubmitMsg(r.msg || '已提交');
                setTimeout(() => setSubmitMsg(''), 3000);
            } else if (Date.now() - startAt > 4000) {
                clearInterval(timer);
                setSubmitMsg('提交超时，请重试');
                setTimeout(() => setSubmitMsg(''), 3000);
            }
        }, 150);
    }

    function getScaleList(scaleName) {
        if (!scaleName) {
            return emConfigList[0].keynoteList
        }
        const found = emConfigList.find(em => {
            return em.name === scaleName
        })
        if (found && found.keynoteList) {
            return found.keynoteList
        }
        return emConfigList[0].keynoteList
    }

    const isCurrentEm = currentKeynote.type === "EM_KN_ZX" || currentKeynote.type === "EM_KN_AI_LOCAL" 
    return (
        <div className="YunEmSet EmCommon">
            <YunSection active={isCurrentEm} className={currentKeynote.type} width="200" height="180">
                <div className="EmItem">
                    <div className="EmItemL">
                        <div className="dd">
                            <p className="keynote">{currentKeynote.newKeyNote}</p>
                            <div>
                                <p className="tune MainColor">{forMatTune(emSharpFlatState.value)}</p>
                                <p className="tune">{forMatTune(sharpFlatState.value)}</p>
                            </div>
                        </div>
                        <p className="scale HoverColor MainColor">{currentKeynote.newScale}</p>
                    </div>
                    <div className="EmItemR">
                        <p className="musicName">将保存您选的基调</p>
                        {submitMsg ? (
                        <p className="musicAuthor" style={{color: "#07f2f3"}}>{submitMsg}</p>
                    ) : (
                        <p className="musicAuthor HoverColor MainColor" onClick={submitReport} style={{cursor:"pointer",textDecoration:"underline"}}>基调不对？点此提交</p>
                    )}
                    </div>
                </div>
                <div className="EmSet">
                    <div className="ScaleItems">
                        {keynoteList}
                    </div>
                    <div className="KeynoteItems">
                        {scaleList}
                    </div>
                </div>
            </YunSection>
        </div>
    )
}

export default YunEmSet;
